import { Video, Music, CheckCircle2 } from 'lucide-react';
import type { PresetProfile } from './transcoding-preset-constants';
import styles from './PresetProfileCard.module.css';

interface PresetProfileCardProps {
  profile: PresetProfile;
  selected: boolean;
  onToggle: () => void;
}

/** Card for selecting a predefined transcoding preset profile. */
export function PresetProfileCard({ profile, selected, onToggle }: PresetProfileCardProps) {
  const { video, audio } = profile.params;
  const resolution = `${video.dimension.width}×${video.dimension.height}`;

  return (
    <button
      type="button"
      className={`${styles.card} ${selected ? styles.selected : ''}`}
      onClick={onToggle}
      aria-pressed={selected}
    >
      {selected && (
        <CheckCircle2 size={16} className={styles.checkIcon} aria-hidden />
      )}

      <div className={styles.name}>{profile.description}</div>
      <div className={styles.mono}>{profile.name}</div>

      <div className={styles.chips}>
        <span className={styles.chip}>{resolution}</span>
        <span className={styles.chip}>{video.fps} fps</span>
      </div>

      <div className={styles.row}>
        <Video size={12} aria-hidden />
        <span>{video.codec} · {video.profile} · {video.bitrateKbps} kbps · GOP {video.gop}</span>
      </div>
      <div className={styles.row}>
        <Music size={12} aria-hidden />
        <span>{audio.codec} · {audio.bitrateKbps} kbps · {(audio.sampleRate / 1000).toFixed(1)} kHz</span>
      </div>
    </button>
  );
}
